const Name = {
    Block: {
        Column: 'column',
        Divider: 'divider',
        Footer: 'footer',
        HeaderText: 'headerText',
        Image: 'image',
        LinkButton: 'button',
        Logo: 'logo',
        Social: 'social',
        Text: 'text',

        Contact: {
            Image: 'contact-image',
            Message: 'contact-message',
            Text: 'contact-meta-text'
        },
        Inventory: {
            Button: 'inventory-button',
            Image: 'inventory-image',
            List: 'inventory-list',
            Text: 'inventory-meta-text'
        },
        Recipient: {
            Text: 'recipient-meta-text'
        }
    },

    Content: {
        EmailBody: 'emailBody',
        InventoryCell: 'inventoryCell',
        InventoryCellOverride: 'inventoryCellOverride',
        Transactional: {
            InventoryCell: `transactional-inventoryCell`
        }
    },

    Group: {
        ImageLeftTextRight: 'image-left-text-right',
        ImageRightTextLeft: 'image-right-text-left'
    }
}
export default Name;